import { MIXPANEL } from "./config";
import mixpanel from "mixpanel-browser";
 
if (MIXPANEL.projectToken) {
    try {
        mixpanel.init(MIXPANEL.projectToken, {
            debug: true,
            track_pageview: true,
            ignore_dnt: true
        });
    }
    catch (e) {
        console.error("Failed to initialize Mixpanel: ", e);
    }
} else {
    console.warn("Mixpanel project token is not set, tracking disabled");

    // Create no-op implementation when token is missing
    // This prevents errors if tracking is called before initialization
    mixpanel.init = () => {};
    mixpanel.track = () => {};
    mixpanel.identify = () => {};
    mixpanel.people = { set: () => {} };
}

// Need to identify the user with email and name
export const identifyUser = (user) => {
  if (!user) return;
  
  // Check if Mixpanel is initialized by checking if the project token exists
  if (!MIXPANEL.projectToken) {
    console.warn("Mixpanel not initialized, skipping user identification");
    return;
  }
  
  try {
    mixpanel.identify(user.email);
    mixpanel.people.set({
      $name: `${user.first_name} ${user.last_name}`,
      $email: user.email
    });
  } catch (e) {
    console.error("Failed to identify user in Mixpanel: ", e);
  }
};

export default mixpanel;